export default __webpack_public_path__ + "static/static-page-banner-t-aa64ac755bd10ee6a5b864a179902c2b.jpg";